import AttendanceListErrorRow from './AttendanceListErrorRow';

export default AttendanceListErrorRow;
